import { render, staticRenderFns } from "./sign-in-modal.vue?vue&type=template&id=4dafba50&scoped=true"
import script from "./sign-in-modal.vue?vue&type=script&lang=js"
export * from "./sign-in-modal.vue?vue&type=script&lang=js"
import style0 from "./sign-in-modal.vue?vue&type=style&index=0&id=4dafba50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dafba50",
  null
  
)

export default component.exports